var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.99997C12.2761 4.99997 12.5 5.22383 12.5 5.49997C12.5 5.77611 12.2761 5.99997 12 5.99997H7.5C6.67157 5.99997 6 6.67154 6 7.49997V16.5C6 17.3284 6.67157 18 7.5 18H16.5C17.3284 18 18 17.3284 18 16.5V12C18 11.7238 18.2239 11.5 18.5 11.5C18.7761 11.5 19 11.7238 19 12V16.5C19 17.8807 17.8807 19 16.5 19H7.5C6.11929 19 5 17.8807 5 16.5V7.49997C5 6.11926 6.11929 4.99997 7.5 4.99997H12ZM17.6129 4.62389L17.7071 4.70708L19.2929 6.29286C19.6534 6.65335 19.6811 7.22058 19.3761 7.61287L19.2929 7.70708L13.1464 13.8535C13.0714 13.9285 12.975 13.9773 12.8716 13.9937L12.7929 14H10.5C10.2545 14 10.0504 13.8231 10.0081 13.5898L10 13.5V11.2071C10 11.101 10.0337 10.9984 10.0952 10.9136L10.1464 10.8535L16.2929 4.70708C16.6534 4.34659 17.2206 4.31886 17.6129 4.62389ZM15.353 7.06018L11 11.4142V13H12.5858L16.939 8.64618L15.353 7.06018ZM17 5.41418L16.06 6.35318L17.646 7.93918L18.5858 6.99997L17 5.41418Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.83633526a175febe045759ec07a4ae26.svg";
export { ForwardRef as ReactComponent };